module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_06.7dad8960.jpg";